module.exports = __webpack_public_path__ + "static/media/cloud_3.436d937f.png";